import { Navigate, useLocation, useNavigate } from "react-router-dom";

const NotFoundInternalPage = () => null;

export default NotFoundInternalPage;
